import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import type { SurveyEpcEstimateQuery } from '@ps/survey-utils';

import { SurveyEpcEstimatePayloadMapper } from '../../api/survey-epc/mappers/survey-epc-estimate.payload.mapper';
import { SurveyEpcApi } from '../../api/survey-epc/survey-epc.api';

@Injectable({ providedIn: 'root' })
export class SurveyEpcService {
  private readonly _api = inject(SurveyEpcApi);

  private readonly _payloadMapper = new SurveyEpcEstimatePayloadMapper();

  public estimate(query: SurveyEpcEstimateQuery): Observable<number> {
    return this._api.estimate(this._payloadMapper.toPayload(query));
  }

  public platform(countryCode: string): Observable<number> {
    return this._api.platform(countryCode);
  }

  public actual(surveyId: number): Observable<number> {
    return this._api.actual(surveyId);
  }
}
